/**
 * Places - Archive (listing view)
 */

'use strict';

var GoogleMapsLoader = require('google-maps');
var cmGoogleMaps = require('../misc/googleMaps');
var helper = require('../misc/helpers');
var layout = require('../misc/layout');

// Constructor
var FrontPlacesArchive = function () {
    if (!$('body').hasClass('post-type-archive-cm-places')) {
        return;
    }

    this.uiColumnsHeight();
    this.uiInitMaterialize();

    GoogleMapsLoader.KEY = cmGoogleMaps.apiKey;
    GoogleMapsLoader.LANGUAGE = 'fr';
    //GoogleMapsLoader.LIBRARIES = ['places'];
    GoogleMapsLoader.load((function(google) {
        this.google = google;

        this.uiResultsSidebar();
        this.uiDisplayGoogleMaps();
        //this.userGeolocation();
        this.getCoordinates();

        $(document).ready((function () {
            this.dropdownCategories();
            this.autocompleteCitiesInput();
            this.searchForm();
            this.populateSearchFormFromCookies();
            this.reinitializeSearch();
            this.toggleSearchForm();
        }).bind(this));
    }).bind(this));
};

FrontPlacesArchive.prototype = {
    google: null,
    map: null,
    infoWindow: null,
    lockAjaxGetResults: false,
    lockAjaxMakerInfo: false,
    coordinates: [],
    markers: [],
    markersCluster: [],
    markerClustererObj: null,
    isFirstCentered: false,

    /**
     * Equal columns heights for places list (left) and the map (right).
     */
    uiColumnsHeight: function() {
        //$('main#content .col-match-height').matchHeight();

        var computeHeight2 = function() {
            var height = $(window).height() - $('header#site-header').height();

            $('main#content #results').css('height', height + 'px');
            $('main#content #map').css('height', height + 'px');
        };

        var computeHeight = function() {
            var height = $(window).height() - $('main#content').offset().top;

            if (height > 0) {
                if ($(window).width() > 992) {
                    // hide the footer horizontal nav menu
                    height = height + 120;
                } else {
                    // the footer is hidden on mobile / tablet devices
                }

                $('main#content #results').css('height', height + 'px');
                $('main#content #map').css('height', height + 'px');
            }
        };

        $(window).on('resize', function() {
            computeHeight2();
        });

        computeHeight2();

        // Disable page scroll (the scroll is only possible through the result sidebar with mCustomScrollbar)
        $('#site-header').addClass('force-no-sticky');
        layout.disableScroll();
    },

    uiInitMaterialize: function() {
        layout.disableMaterializeDropdownOnMobile($('#results form'));
    },

    uiResultsSidebar: function() {
        var self = this;
        var sidebarWidth = $('main#content #results').width();

        // On page load
        $('#results .button-expand').attr('title', comedien.i18n.placesCloseSidebar);

        // On click
        $('#results .button-expand').on('click', function() {
            if ($('#results').hasClass('closed')) {
                // Sidebar is closed, display it
                $('#results').stop().animate({
                    'margin-left': '0px',
                }, 500, function() {
                    var icon = 'first_page';
                    if ($(window).width() < 992) {
                        icon = 'map';
                    }
                    $('#results .button-expand i').text(icon);
                    $('#results').removeClass('closed');
                    self.google.maps.event.trigger($('#map .inner')[0], 'resize');
                    $('#results .button-expand').attr('title', comedien.i18n.placesCloseSidebar);
                });
            } else {
                // Sidebar is opened, close it
                $('#results').stop().animate({
                    'margin-left': '-' + sidebarWidth + 'px',
                }, 500, function() {
                    $('#results .button-expand i').text('last_page');
                    $('#results').addClass('closed');
                    self.google.maps.event.trigger($('#map .inner')[0], 'resize');
                    $('#results .button-expand').attr('title', comedien.i18n.placesExpandSidebar);
                });
            }
        });

        // Expand sidebar
        $('#results .button-expand').hover(
            function() {
                $('#results').addClass('button-expend-hover');
            }, function() {
                $('#results').removeClass('button-expend-hover');
            }
        );

        // Change the button to show/hide map on mobile / tablet devices
        if ($(window).width() < 992) {
            $('#results .button-expand i').text('map');
        }

        // Init scrollbar

        $('#results .results-scroll').mCustomScrollbar({
            axis: 'y',
            scrollInertia: 200,
            theme: 'comedien',
            mouseWheel: {
                preventDefault: true
            },
            callbacks: {
                onTotalScrollOffset: 150, // bug fix for Mac's touchpads
                onTotalScroll: function() {
                    console.log('on total scroll');
                    self.loadMorePlaces(this);
                },
            },
            advanced: {
                updateOnContentResize: false, // We will manually call mCustomScrollbar("update") instead (see below)...
            }
        });

        // "Bug fix": dropdown materialize + overflow hidden of the scrollbar container
        var parentHeight = $('#results').height();
        $('#results .results-scroll #mCSB_1_container').css('min-height', parentHeight + 'px');

        $(window).on('resize', function() {
            $('#results .results-scroll').mCustomScrollbar("update");

            var parentHeight = $('#results').height();
            $('#results .results-scroll #mCSB_1_container').css('min-height', parentHeight + 'px');
        });

        // Bug fix: mCustomScrollbar with Materializ dropdown
        // Temporally disable the mCustomScrollbar scrollbar when the dropdown is open,
        // then reactivate it.

        $(document).on('mouseenter', '#results-searchform .input-field .select-wrapper ul', function () {
            $('#results .results-scroll').mCustomScrollbar('disable');
        });

        $(document).on('mouseleave', '#results-searchform .input-field .select-wrapper ul', function () {
            $('#results .results-scroll').mCustomScrollbar('update');
        });

        /*$('#results-searchform .input-field .select-wrapper ul').hover(
            function () {
                $('#results .results-scroll').mCustomScrollbar('disable');
            },
            function () {
                $('#results .results-scroll').mCustomScrollbar('update');
            }
        );*/

        // Same, but for mobile devices:
        if ($(window).width() < 500) {
            // Disable the scrollbar when the user display the dropdown menu
            $('#results-searchform .select-dropdown').on('click', function() {
                var idSelect = $(this).data('activates');
                var $selectedMenu = $('#' + idSelect);
                if ($selectedMenu.css('display') == 'block') {
                    $('#results .results-scroll').mCustomScrollbar('disable');

                    // Enable the scrollbar when the user click outside the dropdown menu
                    $(document).bind('mousedown touchstart', function(e){
                        if ($selectedMenu.is(e.target) || $selectedMenu.find('*').is(e.target)) {
                            $(this).unbind(e);
                        } else if (!$selectedMenu.find('*').is(e.target)) {
                            $(this).unbind(e);
                        }
                    });
                }
            });

            // Enable the scrollbar when the user select an item in the dropdown menu
            $('#results-searchform ul.select-dropdown li').on('click', function() {
                $('#results .results-scroll').mCustomScrollbar("update");
            });
        }

        var containerHeight = $('#results .results-scroll').height();
        var resultsTopHeight = $('#results .results-top').outerHeight(true);
        var minHeightItems = containerHeight - resultsTopHeight;

        // Hover effect on results items

        var timer;

        $('#results .items .item').mouseenter(function() {
            var that = this;
            timer = setTimeout(function(){
                $('#results .items .item').removeClass('hover');
                $(that).addClass('hover');
            }, 750);
        }).mouseleave(function() {
            clearTimeout(timer);
            $('#results .items .item').removeClass('hover');
        });
    },

    /**
     * Display a Google Map of places.
     *
     * @param google Google API instance
     */
    uiDisplayGoogleMaps: function() {
        var googleMapsOptions = {
            //center: {lat: 46.2, lng: 6.1667}, // Default: Geneva
            center: {lat: 46.801111, lng: 8.226667}, // Center of Switzerland
            zoom: 8,
            maxZoom: 18,
            styles: cmGoogleMaps.style,
            scrollwheel: false,
            navigationControl: false,
            streetViewControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: this.google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeControl: false,
            scaleControl: true,
            draggable: true,
            disableDefaultUI: false,
            disableDoubleClickZoom: false,
        };

        // Create the map
        this.map = new this.google.maps.Map($('#map .inner')[0], googleMapsOptions);

        // Center the map on browser resize (responsive) or sidebar display/hide
        //if (!bowser.mobile && !bowser.tablet) {
        if (!bowser.tablet) {
            this.google.maps.event.addDomListener(window, "resize", (function () {
                var center = this.map.getCenter();
                this.google.maps.event.trigger(this.map, "resize");
                this.map.setCenter(center);
            }).bind(this));
        }

        // Init a blank info window
        this.infoWindow = new this.google.maps.InfoWindow({
            content: $('#map-marker-info')[0]
        });
    },

    uiButtonResetZoom: function() {
        var self = this;

        // On first page load the reset button is hidden.
        // Display the button only if the user change the center of the map.
        this.google.maps.event.addListener(this.map, 'bounds_changed', function(event) {
            if (!$('#map .btn-reset-zoom').is(':visible') && self.isFirstCentered) {
                $('#map .btn-reset-zoom').show();
            }
        });

        $('#map .btn-reset-zoom a').on('click', function() {
            self.setMapZoomAndLocation();
        });
    },

    /**
     * Get the GPS coordinates (latitude / longitude) of current visible (paginated) places.
     */
    getCoordinatesCurrentPaginated: function() {
        var self = this;

        $('#results .items .item').each(function (index, element) {
            var latitude = parseFloat($(this).data("latitude"));
            var longitude = parseFloat($(this).data("latitude"));

            if (latitude > 0 && longitude > 0) {
                self.coordinates.push({
                    'latitude': latitude,
                    'longitude': longitude,
                });
            }
        });
    },

    /**
     * Get the GPS coordinates (latitude / longitude) of all the places.
     */
    getCoordinates: function() {
        var self = this;

        self.ajaxGetAllMarkers(function(response) {
            if (response.success) {
                $.each(response.data.markers, function(key, marker) {
                    var latitude = parseFloat(marker['latitude']);
                    var longitude = parseFloat(marker['longitude']);

                    if (latitude > 0 && longitude > 0) {
                        self.coordinates.push({
                            'idPost': parseInt(marker['idPost']),
                            'country': marker['country'],
                            'latitude': latitude,
                            'longitude': longitude,
                        });
                    }
                });

                self.createMarkers();
                self.showOnMap();
            } else {
                console.log('An error occured!');
            }
        }, function(jqXHR, textStatus) {
            console.log("Request failed: " + textStatus);
        });
    },

    /**
     * Create and position markers on the Google Maps for each places.
     */
    createMarkers: function() {
        var self = this;
        var zindex = 1;

        $.each(this.coordinates, function(key, postData) {
            var latLng = new self.google.maps.LatLng(postData['latitude'], postData['longitude']);

            var iconMarker = {
                url: comedien.assets + 'images/markers/m1.png',
                size: new google.maps.Size(55, 55),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(25, 53)
            };

            var marker = new google.maps.Marker({
                position: latLng,
                icon: iconMarker,
                zIndex: zindex
            });

            // Attach the some post data to the marker
            marker.idPost = postData['idPost'];
            marker.country = postData['country'];

            // Add an onclick listener to show a info window
            self.google.maps.event.addListener(marker, 'click', function() {
                self.showMarkerInfoWindow(this);
            });

            // Add the marker to the marker's cluster array
            self.markersCluster.push(marker);

            zindex++;
        });

        // Create the cluster

        var clusterOptions = {
            averageCenter: true,
            maxZoom: 14,
            styles: [
                {
                    textColor: 'white',
                    textSize: 18,
                    url: comedien.assets + 'images/markers/m2.png',
                    height: 65,
                    width: 65
                },
            ],
            cssClass: 'comedien-marker-clusterer'
        };

        self.markerClustererObj = new MarkerClusterer(self.map, self.markersCluster, clusterOptions);

        // Close the infowindow when clicking somewhere else

        self.google.maps.event.addListener(self.map, 'click', function () {
            //self.infoWindow.close();
            self.hideMarkerInfoWindow();
        });

        // Auto center and zoom the map

        this.setMapZoomAndLocation();
    },

    clearMarkers: function() {
        for (var i = 1; i < this.markers.length; ++i) {
            if (this.markers[i]) {
                this.markers[i].setMap(null);
            }
        }
        this.markers = [];
    },

    /**
     * @param {google.maps.Marker} marker
     */
    showMarkerInfoWindow: function(marker) {
        var self = this;

        if (self.lockAjaxMakerInfo) {
            // Pending AJAX request... do nothing
            return;
        }

        self.lockAjaxMakerInfo = true;

        self.infoWindow.open(self.map, marker);
        $('#map-marker-info .inner').hide();
        $('#map-marker-info .loading').show();

        this.ajaxGetMarkerPlaceInfo(function(response) {
            if (response.success) {
                $('#map-marker-info .title').html(response.data.title);
                $('#map-marker-info .address').html(response.data.address);

                if (response.data.email != '') {
                    $('#map-marker-info .email').html(response.data.email).show();
                } else {
                    $('#map-marker-info .email').hide();
                }

                if (response.data.phone != '') {
                    $('#map-marker-info .phone').html(response.data.phone).show();
                    if (response.data.phone2 != '') {
                        $('#map-marker-info .phone').html(response.data.phone + ' - ' + response.data.phone2);
                    }
                } else {
                    $('#map-marker-info .phone').hide();
                }

                if (response.data.website != '') {
                    $('#map-marker-info .website a').attr('href', response.data.website);
                    $('#map-marker-info .website a').attr('title', response.data.title);
                    $('#map-marker-info .website a').html(response.data.website);
                    $('#map-marker-info .website').show();
                } else {
                    $('#map-marker-info .website').hide();
                }

                if (response.data.isPartner) {
                    $('#map-marker-info .thumbnail .img').removeAttr('style');
                    $('#map-marker-info .thumbnail .img').html('');
                    $('#map-marker-info .label-partner').show();
                    $('#map-marker-info .btn-more').attr('href', response.data.permalink).show();

                    if (response.data.idLogo && parseInt(response.data.idLogo) > 0) {
                        $('#map-marker-info .thumbnail .img').css('background-color', 'transparent');
                    }
                    if (response.data.image && response.data.image != '') {
                        $('#map-marker-info .thumbnail .img').html(response.data.image);
                    }

                    $('#map-marker-info .thumbnail').show();
                } else {
                    $('#map-marker-info .thumbnail').hide();
                    $('#map-marker-info .label-partner').hide();
                    $('#map-marker-info .btn-more').hide();
                }

                $('#map-marker-info .inner').show();
                $('#map-marker-info .loading').hide();
            } else {
                console.log('An error occured!');
            }
            self.lockAjaxMakerInfo = false;
        }, function(jqXHR, textStatus) {
            self.lockAjaxMakerInfo = false;
            console.log("Request failed: " + textStatus);
        }, marker.idPost);
    },

    hideMarkerInfoWindow: function() {
        this.infoWindow.close();
    },

    showOnMap: function() {
        var self = this;

        $('body').on('click', '.showOnMap', function() {
            var item = $(this).closest('.item');
            var idPost = item.data('idpost');

            $.each(self.markersCluster, function (i, marker) {
                if (typeof marker.idPost !== 'undefined' && marker.idPost == idPost) {
                    self.map.panTo(marker.getPosition());
                    self.map.setZoom(17);
                    self.google.maps.event.addListenerOnce(self.map, 'idle', function() {
                        self.showMarkerInfoWindow(marker);
                    });

                    return false;
                }
            });
        });
    },

    setMapZoomAndLocation: function() {
        var self = this;

        // Set a minimum zoom (if we got only 1 marker or all markers are on the same address,
        // the map will be zoomed too much)

        this.google.maps.event.addListenerOnce(this.map, 'bounds_changed', function(event) {
            if (this.getZoom() > 15) {
                this.setZoom(15);
            }

            if (!self.isFirstCentered) {
                self.isFirstCentered = true;

                setTimeout(function() {
                    self.uiButtonResetZoom();
                }, 2000); // +/- panTo animation duration
            }
        });

        // Zoom to fit all markers (but only for Switzerland places)

        var bounds = new this.google.maps.LatLngBounds();
        for (var i = 0; i < this.markersCluster.length; i++) {
            if (typeof this.markersCluster[i].country !== 'undefined' && this.markersCluster[i].country == 'ch') {
                bounds.extend(this.markersCluster[i].getPosition());
            }
        }

        //this.map.fitBounds(bounds);
    },

    userGeolocation: function() {
        var self = this;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                self.map.setCenter(pos);
            }, function() {
                // The Geolocation service failed or the user refuse to accept to be localized
                // Fallback: default to Geneva
                self.map.setCenter(self.map.getCenter());
            });
        } else {
            // Browser doesn't support Geolocation
            // Fallback: default to Geneva
            self.map.setCenter(self.map.getCenter());
        }
    },

    dropdownCategories: function() {
        var $form = $('#results .results-top form');
        var $selectCategory = $('select#category', $form);
        var $selectSubCategory = $('select#subCategory', $form);

        $selectCategory.change(function() {
            if ($(this).val() != '') {
                var selectedValue = $(this).val();

                // Remove all options
                $selectSubCategory.find('option').remove();
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.placesDropdownSubCategory,
                    disabled: 'disabled',
                    selected: 'selected',
                }));
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.placesDropdownAll
                }));

                // Inset new options
                $.each(places.subCategories, function (i, item) {
                    if (selectedValue == item.parent_id) {
                        $selectSubCategory.append($('<option>', {
                            value: item.term_id,
                            text : item.name
                        }));
                    }
                });
            } else {
                $selectSubCategory.find('option').remove();
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.placesDropdownSubCategory,
                    disabled: 'disabled',
                    selected: 'selected',
                }));
            }

            if ($(this).val() != '') {
                $selectSubCategory.removeAttr('disabled');
            } else {
                $selectSubCategory.attr('disabled', 'disabled');
            }

            $selectSubCategory.formSelect('destroy');
            $selectSubCategory.formSelect();
        });
    },

    loadMorePlaces: function(el) {
        var self = this;
        var nbDisplayedPlaces = this.getNumberDisplayedPlaces();
        var nbTotalPlaces = places.nbTotalPlaces;

        if (nbDisplayedPlaces < nbTotalPlaces) {
            if (this.lockAjaxGetResults) {
                // Pending AJAX request... do nothing
                return;
            }

            this.lockAjaxGetResults = true;

            // Display the loading spinner
            $('#results .loading').fadeIn();
            $('#results .results-scroll').mCustomScrollbar('update');
            $('#results .results-scroll').mCustomScrollbar('scrollTo', 'bottom');

            // Fetch the posts
            self.ajaxGetResults(function(response) {
                if (response.success) {
                    setTimeout(function() {
                        // Hide the loading spinner
                        $('#results .loading').fadeOut();

                        // Append the new places in the bottom of the results list
                        $('#results .items').append(response.data.places);
                        $('#results .results-scroll').mCustomScrollbar("update");
                    }, 1000);
                } else {
                    console.log('An error occured!');
                }

                self.lockAjaxGetResults = false;
            }, function(jqXHR, textStatus) {
                self.lockAjaxGetResults = false;
                console.log("Request failed: " + textStatus);
            }, nbDisplayedPlaces);
        }
    },

    getNumberDisplayedPlaces: function() {
        return $('#results .items .item').length;
    },

    autocompleteCitiesInput: function() {
        var cities = {};

        $.each(places.cities, function (i, item) {
            cities[item] = null;
        });

        $('#results-searchform #city').autocomplete({
            data: cities,
        });
    },

    searchForm: function() {
        var self = this;

        $('#results-searchform').on('submit', function(e) {
            e.preventDefault();

            if (self.lockAjaxGetResults) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxGetResults = true;

            // Display the loading spinner
            $('#results .items').html('');
            $('#results .loading').fadeIn();
            $('#results .results-scroll').mCustomScrollbar('update');
            $('#results .results-scroll').mCustomScrollbar('scrollTo', 'top');

            var startTime = new Date().getTime();

            self.ajaxGetResults(function(response) {
                if (response.success) {
                    var fakeLoadingTime = 0;
                    var requestTime = new Date().getTime() - startTime;

                    if (requestTime < 1000) {
                        fakeLoadingTime = 1000 - requestTime;
                    }

                    var appendItems = function() {
                        // Hide the loading spinner
                        $('#results .loading').fadeOut();

                        // Display the places in the results list
                        $('#results .items').html(response.data.places);
                        $('#results .results-scroll').mCustomScrollbar("update");

                        // Update the total number of places count
                        var total = parseInt(response.data.nbTotalPlaces);
                        if (total == 0) {
                            $('#results .results-top h1').html('<span>' + comedien.i18n.placesTitleCountZero + '</span>' + ' ' + comedien.i18n.placesTitleCountOrganisme);
                        } else if (total == 1) {
                            $('#results .results-top h1').html('<span>' + total + '</span>' + ' ' + comedien.i18n.placesTitleCountOrganisme);
                        } else {
                            $('#results .results-top h1').html('<span>' + total + '</span>' + ' ' + comedien.i18n.placesTitleCountOrganisme + 's');
                        }
                    };

                    if (fakeLoadingTime > 0) {
                        setTimeout(appendItems(response), fakeLoadingTime);
                    } else {
                        appendItems(response);
                    }

                    // Remember the search criteria for 1 day through cookies

                    helper.setCookie('place_searchform_category', parseInt($('#results-searchform #category').val()), 1);
                    helper.setCookie('place_searchform_subcategory', parseInt($('#results-searchform #subCategory').val()), 1);
                    helper.setCookie('place_searchform_canton', $('#results-searchform #canton').val(), 1);
                    helper.setCookie('place_searchform_city', $('#results-searchform #city').val(), 1);
                    helper.setCookie('place_searchform_title', $('#results-searchform #title').val(), 1);
                } else {
                   M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                }

                self.lockAjaxGetResults = false;
            }, function(jqXHR, textStatus) {
                self.lockAjaxGetResults = false;
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            }, 0);
        });
    },

    populateSearchFormFromCookies: function() {
        var category = helper.getCookie('place_searchform_category');
        var subCategory = helper.getCookie('place_searchform_subcategory');
        var canton = helper.getCookie('place_searchform_canton');
        var city = helper.getCookie('place_searchform_city');
        var title = helper.getCookie('place_searchform_title');

        var triggerSearch = false;

        if (category > 0) {
            $('#results-searchform #category').val(category);
            $('#results-searchform #category').formSelect('destroy');
            $('#results-searchform #category').formSelect();
            $('#results-searchform #category').trigger('change');
            triggerSearch = true;
        }
        if (subCategory > 0) {
            $('#results-searchform #subCategory').val(subCategory)
            $('#results-searchform #subCategory').formSelect('destroy');
            $('#results-searchform #subCategory').formSelect();
            $('#results-searchform #subCategory').trigger('change');
            triggerSearch = true;
        }
        if (canton != '') {
            $('#results-searchform #canton').val(canton);
            $('#results-searchform #canton').formSelect('destroy');
            $('#results-searchform #canton').formSelect();
            triggerSearch = true;
        }
        if (city != '') {
            $('#results-searchform #city').val(city);
            M.updateTextFields();
            triggerSearch = true;
        }
        if (title != '') {
            $('#results-searchform #title').val(title);
            M.updateTextFields();
            triggerSearch = true;
        }

        if (triggerSearch) {
            // Trigger the search button to update the results
            $('#results-searchform').submit();
        }
    },

    reinitializeSearch: function() {
        $('.btn-reinit').on('click', function(e) {
            e.preventDefault();

            // Clear the search criteria

            $('#results-searchform #category').val('');
            $('#results-searchform #category').formSelect('destroy');
            $('#results-searchform #category').formSelect();

            $('#results-searchform #subCategory').val('')
            $('#results-searchform #subCategory').formSelect('destroy');
            $('#results-searchform #subCategory').formSelect();

            $('#results-searchform #canton').val('');
            $('#results-searchform #canton').formSelect('destroy');
            $('#results-searchform #canton').formSelect();

            $('#results-searchform #city').val('');
            $('#results-searchform #title').val('');
            M.updateTextFields();

            // Clear the cookies

            helper.deleteCookie('place_searchform_category');
            helper.deleteCookie('place_searchform_subcategory');
            helper.deleteCookie('place_searchform_canton');
            helper.deleteCookie('place_searchform_city');
            helper.deleteCookie('place_searchform_title');

            // Trigger the search button to update the results

            $('#results-searchform').submit();
        });
    },

    toggleSearchForm: function() {
        $('.btn-hide-search-form').on('click', function(e) {
            e.preventDefault();

            if ($('#results-searchform').is(":visible")) {
                $('#results-searchform').slideUp(500, function() {
                    $('.btn-show-search-form').fadeIn(250);
                });
            }
        });

        $('.btn-show-search-form').on('click', function(e) {
            e.preventDefault();

            if ($('#results-searchform').is(":hidden")) {
                $('.btn-show-search-form').hide();
                $('#results-searchform').slideDown(500);
            }
        });
    },

    /**
     * Fetch posts.
     *
     * @param {function} callbackDone   Function executed when the AJAX request is resolved
     * @param {function} callbackFail   Function executed when the AJAX request is rejected
     * @param {number}   offset         Exclude first 'n' records
     */
    ajaxGetResults: function(callbackDone, callbackFail, offset) {
        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'places.get_results',
                security: comedien.security,
                nbDisplayedPlaces: offset,
                category: parseInt($('#results-searchform #category').val()),
                subCategory: parseInt($('#results-searchform #subCategory').val()),
                canton: $('#results-searchform #canton').val(),
                city: $('#results-searchform #city').val(),
                title: $('#results-searchform #title').val(),
            }
        }).done(callbackDone).fail(callbackFail);
    },

    ajaxGetAllMarkers: function(callbackDone, callbackFail) {
        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'places.get_all_markers',
                security: comedien.security,
                category: parseInt($('#results-searchform #category').val()),
                subCategory: parseInt($('#results-searchform #subCategory').val()),
                canton: $('#results-searchform #canton').val(),
                city: $('#results-searchform #city').val(),
                title: $('#results-searchform #title').val(),
            }
        }).done(callbackDone).fail(callbackFail);
    },

    ajaxGetMarkerPlaceInfo: function(callbackDone, callbackFail, idPost) {
        $.ajax({
            url: comedien.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'places.get_marker_place_info',
                security: comedien.security,
                idPost: idPost
            }
        }).done(callbackDone).fail(callbackFail);
    },
};

module.exports = new FrontPlacesArchive();
